import { render, staticRenderFns } from "./DisplaySettings.vue?vue&type=template&id=510afc52&scoped=true&"
import script from "./DisplaySettings.vue?vue&type=script&lang=js&"
export * from "./DisplaySettings.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySettings.vue?vue&type=style&index=0&id=510afc52&prod&scoped=true&lang=scss&"
import style1 from "./DisplaySettings.vue?vue&type=style&index=1&id=510afc52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510afc52",
  null
  
)

export default component.exports